// extracted by mini-css-extract-plugin
module.exports = {"phoneNumber":"IntlPhoneNumberField_phoneNumber__35XlU","dropdownHidden":"IntlPhoneNumberField_dropdownHidden__21eAX"};